import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import { iDataUserSuscription } from "../../../../interfaces/SuperAdmin/Pages/iDataUserSuscription";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import RowSuscriptionInUser from "./RowSuscriptionInUser";

interface Props {
  suscripciones: iDataUserSuscription[];
  assignToDeleteSuscr: (suscrId: string) => void;
}

export const UserSuscriptTable: React.FC<Props> = ({
  suscripciones,
  assignToDeleteSuscr,
}) => {
  return (
    <Table
      size="small"
      aria-label="details"
      sx={{
        backgroundColor: "#E3EEFA",
        borderRadius: "10px",
        marginBottom: "20px",
      }}
    >
      <TableHead>
        <TableRow>
          <StyledTableCell align="center">N°</StyledTableCell>
          <StyledTableCell align="center">Plan</StyledTableCell>
          <StyledTableCell align="center">Fecha de inicio</StyledTableCell>
          <StyledTableCell align="center">Fecha de expiración</StyledTableCell>
          <StyledTableCell align="center">Créditos usados</StyledTableCell>
          <StyledTableCell align="center">Estado</StyledTableCell>
          <StyledTableCell align="center">Acciones</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {suscripciones.length ? (
          suscripciones.map((sub, index) => (
            <RowSuscriptionInUser
              key={sub.id_suscripcion}
              sub={sub}
              index={index + 1}
              assignToDeleteSuscr={assignToDeleteSuscr}
            />
          ))
        ) : (
          <TableRow>
            <StyledTableCell
              colSpan={9}
              sx={{
                paddingTop: "12px",
                paddingBottom: "12px",
                textAlign: "center",
              }}
            >
              No hay campos aún
            </StyledTableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
